var React = require('react');

function Shape5 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"fill":"#E4D3C8","d":"M8.752,145.527c0,0-17.127-16.226,0-34.253s45.07,6.31,51.38-10.816\n\t\ts-5.003-39.643,0.901-63.998c7.211-29.746,42.365-36.957,65.801-24.338c23.438,12.619,45.07,1.557,62.196-9.137\n\t\ts48.675,8.235,60.393,42.488s-5.407,83.828-18.026,100.054c-12.621,16.226-75.718,44.168-79.323,44.168\n\t\tS8.752,145.527,8.752,145.527"})),React.createElement("path",{"fill":"#E4D3C8","d":"M1.775,53.586c0,0,2.705-26.141,19.831-26.141s21.633,5.409,17.126,17.127S29.72,62.599,15.297,68.909\n\tS0.088,61.607,1.775,53.586","key":1})]);
}

Shape5.defaultProps = {"version":"1.1","id":"Warstwa_1","x":"0px","y":"0px","width":"253.338px","height":"189.695px","viewBox":"0 0 253.338 189.695","enableBackground":"new 0 0 253.338 189.695","xmlSpace":"preserve"};

module.exports = Shape5;

Shape5.default = Shape5;
